export default [
  {
    path: '/internal-agent',
    name: 'internalAgent',
    component: () => import('@/views/pages/internalAgentManagement/InternalAgent.vue'),
  }
]